/**
 * Sunucu kodu -> CEVIRI ANAHTARI haritalari (rapor ekranlari).
 *
 * DEGERLER METIN DEGIL ANAHTAR. Bu dosya modul seviyesinde yasiyor; burada t()
 * cagirmak metni IMPORT ANINDA dondurur ve dil degistiginde bayat birakir.
 * Adlarin `..._LABEL_KEYS` olmasi kullanim hatasini OKURKEN belli etsin diye:
 * `{TASK_STATUS_LABEL_KEYS[c]}` ekranda ham anahtar basar, dogrusu
 * `{t(TASK_STATUS_LABEL_KEYS[c])}`. (src/i18n/__tests__/keys.test.ts hem
 * anahtarlarin varligini hem de t()'siz basimi sinar.)
 */

/**
 * Panel durum kutulari. Sunucudaki `accepted` / `rejected` / `warning`
 * ayrimi "bu gorevin kazanan teklifi BENIM miydi" sorusuna dayaniyor
 * (db.js readExchange), o yuzden etiketler teklif diliyle yaziliyor.
 */
export const DASHBOARD_STATUS_LABEL_KEYS: Readonly<Record<string, string>> = Object.freeze({
  accepted: 'dashboard.statusAccepted',
  rejected: 'dashboard.statusRejected',
  warning: 'dashboard.statusWarning',
});

/** Panel durumu -> Chip/StatTile tonu. */
export const DASHBOARD_STATUS_TONES: Readonly<Record<string, 'success' | 'danger' | 'warning'>> =
  Object.freeze({
    accepted: 'success',
    rejected: 'danger',
    warning: 'warning',
  });

/**
 * Islem durumu kodu -> etiket. Bilinmeyen bir kod gelirse ekran HAM KODU
 * basar: yeni bir sunucu surumu bu raporu bos birakmamali.
 */
export const TASK_STATUS_LABEL_KEYS: Readonly<Record<string, string>> = Object.freeze({
  new: 'report.statusNew',
  completed: 'report.statusCompleted',
  pending: 'report.statusPending',
  // Buronun ilk onayi (2026-09-26): musterinin odemesi alindi, gonderim bekleniyor.
  payment_received: 'report.statusPaymentReceived',
  warning: 'report.statusWarning',
  cancelled: 'report.statusCancelled',
  passive: 'report.statusPassive',
  // Supurucunun yazdigi kapanislar (2026-09-07) ve platform cozumu (2026-09-23, karar Q3).
  expired: 'report.statusExpired',
  no_offers: 'report.statusNoOffers',
  resolved: 'report.statusResolved',
  refunded: 'report.statusRefunded',
});

/** Uye tipi -> rozet etiketi (personel performansi bolumu). */
export const REPORT_MEMBER_TYPE_LABEL_KEYS: Readonly<Record<string, string>> = Object.freeze({
  admin: 'report.memberAdmin',
  staff: 'report.memberStaff',
});

/**
 * Kod -> CEVRILMIS metin. `t` disaridan aliniyor (bu dosya modul seviyesinde).
 * Haritayi disari acmak yerine fonksiyon sunmanin sebebi cagri yerinin t() ile
 * sarmayi UNUTAMAMASI; bilinmeyen kodda ham kod doner.
 */
export const translateCode = (
  t: (key: string) => string,
  map: Readonly<Record<string, string>>,
  code: string,
): string => {
  const key = map[code];
  return key === undefined ? code : t(key);
};
